<template>
    <button
        type="button"
        id="prev-step"
        class="btn btn-light-primary font-weight-bolder dm-btn-wizard"
        data-wizard-type="action-prev"
        @click="$emit('clicked')"
    >
        <span class="svg-icon svg-icon-md mr-3">
            <ArrowLeftSvg />
        </span>
        {{ translate("Previous") }}
    </button>
</template>

<script>
import ArrowLeftSvg from "@/svg/ArrowLeftSvg.vue";

export default {
    components: { ArrowLeftSvg },

    emits: ["clicked"],
};
</script>
